// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__OXYr6","block":"styles_block__RzJ0Z"};